export enum VoucherTypeEnum {
	Labour = 1,
	ReplacementParts = 2,
	Diagnostic = 3,
}
